// extracted by mini-css-extract-plugin
export default {"nav":"Profile_nav__X4e5H"};